/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElement } from '@one1-dev/ibms-global-jobs-web-components/ibms-job-poller';
import '@one1-dev/ibms-global-jobs-web-components/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Browser-only entry: registers <ibms-job-poller> once. Never in main.server.ts —
defineCustomElement();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));


